import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../components/css/storysection.css";
import storyImage from "../media/images/Story/028.jpg"; // Ensure this path is correct
import { Container, Row, Col, Card } from "react-bootstrap";
import Partners from "./pages/parteners";



import img1 from "../media/images/garary/Swimming.jpg";
import img2 from "../media/images/garary/FH_UG-751.jpg";
import img3 from "../media/images/garary/020.jpg";
import img4 from "../media/images/garary/g29.jpg";
import img5 from "../media/images/garary/FH_UG-689.jpg";
import img6 from "../media/images/garary/082.jpg";
import img7 from "../media/images/garary/055.jpg";
import img8 from "../media/images/garary/FH_UG-58.jpg";
import img9 from "../media/images/garary/085.jpg";
import roomImg from "../media/images/garary/032.jpg";


const amenities = [
  { title: "Swimming Pool", image: img1 },
  { title: "Restaurant", image: img3 },
  { title: "Tennis Court", image: img4 },
  { title: "Gardens & Grounds", image: img5 },
  { title: "Retreat", image: img6 },
  { title: "Golf Cart", image: img7 },
  { title: "Hilltop Views", image: img8 },
  { title: "Prayer Walks", image: img9 },
];

const features = [
  {
    icon: "✝️",
    title: "Faith & Fellowship",
    text: "Rooted in Christian love — a place for prayer, worship, and spiritual connection in a tranquil hilltop setting.",
  },
  {
    icon: "🕊️",
    title: "Peace & Renewal",
    text: "Our serene gardens, natural rock formations, and panoramic lake views are designed for rest, reflection, and reconnection.",
  },
  {
    icon: "🤝",
    title: "Warm Hospitality",
    text: "Every guest is family. From arrival to departure, our attentive team ensures you feel genuinely welcomed and cared for.",
  },
];

const StorySection = () => {
  return (
    <>
    <section className="story-section">
    <section className="container my-5">
      <div className="row align-items-center">
        
        {/* LEFT IMAGE */}
        <div className="col-lg-6 mb-4 mb-lg-0" data-aos="fade-right">
          <div className="story-img-wrapper">
            <img
              src={storyImage}
              alt="Resort"
              className="img-fluid rounded story-img"
            />
          </div>
        </div>

        {/* RIGHT TEXT */}
        <div className="col-lg-6" data-aos="fade-right" data-aos-delay="200">
          <p className="text-success fw-semibold small-title">
            OUR STORY
          </p>

          <h2 className="display-5 fw-semibold mb-4">
            A Sanctuary of Peace, Hospitality, and Reflection
          </h2>

          <p className="text-muted mb-3">
            Nestled on Mutungo Hill in the heart of Kampala, Father's House
            Church Resort is more than accommodation — it is a place where
            guests find genuine peace, warm hospitality, and spiritual renewal.
          </p>

          <p className="text-muted mb-3">
            Founded on Christian values, our resort offers a serene retreat
            environment with lush tropical gardens, natural rock formations,
            and panoramic views of Lake Victoria.
          </p>

          <p className="text-muted mb-4">
            Every detail — from our comfortable rooms to our attentive service —
            is designed to help you rest, reflect, and reconnect with what
            matters most.
          </p>

          <a href="about" className="story-link">
            Discover Our Story →
          
          </a>
        </div>

      </div>
    </section>

    <Partners />{/* our partners */}

     <section className="py-5 ">
        {/* TOP CARDS */}
        <Row className="mb-0">
          {features.map((item, index) => (
            <Col md={4} key={index} className="mb-3" data-aos="zoom-in" data-aos-delay={index * 100}>
              <Card className="feature-card text-center h-100">
                <Card.Body>
                  <div className="icon mb-3">{item.icon}</div>
                  <Card.Title className="fw-bold">
                    {item.title}
                  </Card.Title>
                  <Card.Text className="text-muted">
                    {item.text}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* IMAGE GRID */}
        <Row >
          <Col md={4} className="mb-4" data-aos="fade-up" data-aos-delay="100">
            <img src={img1} alt="pool" className="img-fluid rounded" />
          </Col>

          <Col md={4} className="mb-4" data-aos="fade-up" data-aos-delay="200">
            <img src={img2} alt="garden" className="img-fluid rounded" />
          </Col>

          <Col md={4} className="mb-4" data-aos="fade-up" data-aos-delay="300">
            <img src={img3} alt="restaurant" className="img-fluid rounded" />
          </Col>
        </Row>

    </section>
    <section className="hotel-features">
      <Container fluid>
        <Row className="g-0">

          {/* LEFT IMAGE */}
          <Col md={6} data-aos="fade-right">
            <div className="feature-image">
              <img src={roomImg} alt="hotel room" />
            </div>
          </Col>

          {/* RIGHT CONTENT */}
          <Col md={6} className="feature-content d-flex align-items-center" data-aos="zoom-in">
            <div className="content-wrapper">
              <h3 className="title">Hotel Features</h3>

              <ul className="feature-list">
                <li>Check-in: 15:00 Hrs - Check out: 11:00 Hrs</li>
                <li>Airport shuttle service</li>
                <li>Close proximity to major shopping malls</li>
                <li>Free High-Speed Wi-Fi</li>
                <li>Restaurants </li>
                <li>Conference & Meeting facilities</li>
                <li>Lush Green Gardens</li>
              </ul>

              {/* BOTTOM ICONS */}
              <Row className="text-center mt-2 icons-row">
                <Col>
                  <div className="icon-circle">🍽️</div>
                  <p>Top Rated Restaurant</p>
                </Col>

                <Col>
                  <div className="icon-circle">🏨</div>
                  <p>Eco Friendly</p>
                </Col>

                <Col>
                  <div className="icon-circle">🛡️</div>
                  <p>Safe and Secure</p>
                </Col>
              </Row>
            </div>
          </Col>

        </Row>
      </Container>
    </section>
    </section>
     <section className="amenities-section py-5">
      <Container>
        {/* HEADER */}
        <div className="text-center mb-5" data-aos="fade-down">
          <small className="subtitle">RESORT AMENITIES</small>
          <h2 className="title">
            Everything You Need for a Comfortable Stay
          </h2>
        </div>

        {/* GRID */}
        <Row>
          {amenities.map((item, index) => (
            <Col md={3} sm={6} xs={12} key={index} className="mb-4" data-aos="zoom-in" data-aos-delay={index * 100}>
              <div className="amenity-card">
                <img src={item.image} alt={item.title} />

                {/* OVERLAY */}
                <div className="overlayh">
                  <h5>{item.title}</h5>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
    </>
  );
};

export default StorySection;
